<template>
    <div class="w-full max-w-4xl flex flex-col items-start justify-start ">
        <div class="text-black text-lg font-semibold mt-10">
            Mein Feedback
        </div>
        <review
            v-for="feedback in GET_FEEDBACK"
            :key="feedback.id"
            :reviewId="feedback.id"
            :type="'feedback'"
        />

        <custom-button
            @click="VALIDATE_REVIEW"
            class="w-72 h-11 mt-10"
            :text="'Feedback einreichen'"
            :bgColor="'bg-primary'"
            :textColor="'text-white'"
            :id="'feedback-button'"
        />
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import { getData } from "../../../common/dataHelper";
import CustomButton from "../../../components/input/CustomButton.vue";
import {
    COURSE_TYPES,
    HELPER_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../../../store/types";
import Review from "./reviews/Review.vue";

export default defineComponent({
    components: { CustomButton, Review },
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({});
        /**
         *  Functions
         */

        async function VALIDATE_REVIEW() {
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
                "feedback-button"
            );
            const response = await store.dispatch(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.VALIDATE_REVIEW}`,
                { type: "feedback" }
            );
            store.commit(
                `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
                "feedback-button"
            );
            if (getData(response, "status") == 200) {
                store.commit(
                    `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                    null
                );
                // ! TODO validate rsponse (feedback done + has certificate +... )
                GET_COURSE.value.feedback_finished = true;
                store.commit(
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                    "certificate"
                );
            }
        }
        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const GET_FEEDBACK = computed(() => {
            if (getData(GET_COURSE, "value.reviews.feedback") == null) {
                return [];
            }
            return GET_COURSE.value.reviews.feedback;
        });

        /**
         *  Created
         */

        return {
            state,
            VALIDATE_REVIEW,
            GET_COURSE,
            GET_FEEDBACK,
        };
    },
});
</script>
